module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "common-pagination"
  }, [_c('div', {
    staticClass: "paginationLeft"
  }, [_vm._v("1页" + _vm._s(_vm.pageSize) + "条，共计" + _vm._s(_vm.total) + "条")]), _vm._v(" "), _c('div', [_c('el-pagination', {
    attrs: {
      "background": _vm.background,
      "current-page": _vm.currentPage,
      "page-size": _vm.pageSize,
      "layout": _vm.layout,
      "total": parseInt(_vm.total)
    },
    on: {
      "update:currentPage": function($event) {
        _vm.currentPage = $event
      },
      "update:current-page": function($event) {
        _vm.currentPage = $event
      },
      "update:pageSize": function($event) {
        _vm.pageSize = $event
      },
      "update:page-size": function($event) {
        _vm.pageSize = $event
      },
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-221ade45"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/tablePagination.vue
// module id = 3496
// module chunks = 103